import { canExploreSignupDashboard } from '@/components/signup/activation';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { maskPhone } from '@/utils/maskPhone';

export function usePhoneMask() {
  const isActivated = useSelector((state: any) => canExploreSignupDashboard(state.auth) ? true : state.auth?.activated);
  return useCallback(<T,>(value: T) => maskPhone(value, isActivated), [isActivated]);
}
